// Module
var code = " <div class=\"level\" id=\"optionCurrencySelector\"> <div class=\"level-left\"> <div id=\"currencyButtons\" class=\"level-item buttons\"></div> </div> </div> ";
// Exports
export default code;